import { render, staticRenderFns } from "./EditSingleClaimAmountDialog.vue?vue&type=template&id=483fcf82&scoped=true&lang=pug&"
import script from "./EditSingleClaimAmountDialog.vue?vue&type=script&lang=js&"
export * from "./EditSingleClaimAmountDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "483fcf82",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VForm } from 'vuetify/lib/components/VForm';
installComponents(component, {VForm})
